import { useId } from "react";
import type { FormCheckboxProps } from "./Interfaces";

export function useCheckbox({
  onCheckedChange,
  onChange,
  error,
  message,
  validation,
  id,
}: FormCheckboxProps) {
  const uid = useId();
  const checkboxId = id ?? `chk-${uid}`;

  const finalMessage = error ?? message;
  const finalValidation = error ? "error" : validation;

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    onChange?.(e);
    onCheckedChange?.(e.target.checked);
  };
  return { checkboxId, finalMessage, finalValidation, handleChange };
}
